import * as React from 'react';
import Modal from '@roo/roo/Modal/Modal';
import Toast from '@roo/roo/Toast/Toast';
import Upload from '@roo/roo/Upload';
import Icon from '@roo/roo/Icon';
import Input from '@roo/roo/Input';
import { FileModel } from '@roo/roo/Upload/interface';
import { CancelDetailRes } from '../../api';

const { Textarea } = Input;
interface P {
    data?: CancelDetailRes;
    onCancel: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
    onConfirm: (list: FileModel[], extReason: string) => void;
}

const { useState } = React;

const maxFileNum = 3;

const RejectModal: React.FC<P> = ({ onCancel, onConfirm }) => {
    const [fileList, setFileList] = useState<FileModel[]>([]);
    const [extReason, setExtReason] = useState<string>('');
    const validityCallback = (files: FileModel[], fileList: FileModel[]) => {
        if (files.length + fileList.length > maxFileNum) {
            Toast.open({
                children: `最多只能上传${maxFileNum}个文件`,
                closable: true,
                duration: 0,
            });
            return false;
        }
        return true;
    };
    const handleChange = (file: FileModel, fileList: FileModel[]) => {
        setFileList(fileList);
    };
    const handleRemove = (file: FileModel, fileList: FileModel[]) => {
        setFileList([...fileList]);
    };
    const handleExtReasonChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setExtReason(e.target.value);
    };
    const isHideUploadIcon = fileList.length >= maxFileNum;

    const handleConfirm = () => {
        if (fileList.length < 1) {
            Toast.open({
                children: '至少需要上传一张沟通图片',
                closable: true,
                duration: 2000,
            });
            return;
        }
        onConfirm(fileList, extReason);
    };

    return (
        <Modal visible onCancel={onCancel} onConfirm={handleConfirm}>
            <h2>请先与商家线下沟通协调，并上传协调一致证明！</h2>
            <p>上传协调结果</p>
            <Upload
                multiple
                showUploadList
                showType="card"
                onRemove={handleRemove}
                onChange={handleChange}
                onFail={(error: Error) => {
                    Toast.open({
                        title: error.message,
                    });
                }}
                validityCallback={validityCallback}
                style={{ width: '400px' }}
                action="/api/image/uploadV2"
                name="img"
                accept=".png,.jpg"
            >
                {isHideUploadIcon ? null : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly',
                            alignItems: 'center',
                            cursor: 'pointer',
                            height: '100%',
                        }}
                    >
                        <Icon name="plus" size={30} />
                        <div>上传文件</div>
                    </div>
                )}
            </Upload>
            <p>请填写驳回原因</p>
            <Textarea
                placeholder="驳回原因"
                value={extReason}
                onChange={handleExtReasonChange}
                statistics
                maxLength={100}
                resize="horizontal"
                rows={5}
                cols={40}
            />
        </Modal>
    );
};

export default RejectModal;
